import ValidationErrorsSnackbar from "@features/builder/graph/validation/ValidationErrorsSnackbar"
import { enqueueSnackbar } from "notistack"

export const raiseEmptyGraphError = () => {
  enqueueSnackbar("", {
    persist: true,
    anchorOrigin: { horizontal: "right", vertical: "top" },
    content: (key) => (
      <ValidationErrorsSnackbar
        id={key}
        errors={["No nodes - Add some first"]}
        title="Validation error"
      />
    ),
  })
}

const raiseErrorsDrawerNotification = (message: string, title = "Validation error") => {
  enqueueSnackbar(message, {
    autoHideDuration: 5_000,
    preventDuplicate: true,
    anchorOrigin: { horizontal: "right", vertical: "top" },
    content: (key) => <ValidationErrorsSnackbar id={key} errors={[message]} title={title} />,
  })
}

export const raiseGraphValidationErrors = () => {
  raiseErrorsDrawerNotification(
    "Review and fix graph validation errors in the Errors Drawer before continuing.",
  )
}

export const raisePresamplingValidationResults = () => {
  raiseErrorsDrawerNotification(
    "Review graph validation results in the Errors Drawer.",
    "Validation result",
  )
}
